import { render } from "./ObjectMainPage.vue?vue&type=template&id=7aba0d1f&scoped=true"
import script from "./ObjectMainPage.vue?vue&type=script&lang=js"
export * from "./ObjectMainPage.vue?vue&type=script&lang=js"

import "./ObjectMainPage.vue?vue&type=style&index=0&id=7aba0d1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aba0d1f"]])

export default __exports__